import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { Invoice } from '../../model/invoice';
import { CreditInvoiceCommandHandlerResolver } from '../../service/command/credit-invoice-command-handler-resolver.service';
import { CreditInvoiceService } from '../../service/data/credit-invoice.service';
import { InvoiceDeliveriesComponent } from '../invoice-deliveries/invoice-deliveries.component';

@Component({
    selector: 'app-credit-invoice-list',
    templateUrl: './credit-invoice-list.component.html',
    styleUrls: ['./credit-invoice-list.component.scss'],
    providers: [CreditInvoiceCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditInvoiceListComponent extends CommandController implements OnInit {
  constructor(
    private _dataService: CreditInvoiceService,
    cdf: ColumnDefinitionFactory,
    commandDispatcher: CommandDispatcher,
    handlerResolver: CreditInvoiceCommandHandlerResolver
  ) {
    super(commandDispatcher, handlerResolver);
    this.columnDefinitions = [
      cdf.create('INVOICE.INVOICE_NUMBER', 'invoiceNumber'),
      cdf.create('INVOICE.RECIPIENT_NAME', 'invoiceRecipient'),
      cdf.createDate('INVOICE.DUE_DATE', 'dueDate'),
      cdf.createMoney('INVOICE.INVOICEAMOUNT', 'amount'),
      cdf.createMoney('INVOICE.REMAINING_AMOUNT', 'remainingAmount'),
      cdf.createComponentBased('INVOICE.DELIVERED_WITH', 'usedDeliveryMethods', InvoiceDeliveriesComponent),
    ];
    this.contextMenuDefinition = [
      new MenuItemDefinition('INVOICE.COMMAND.GETPDF', invoiceCommand.getpdf),
      new MenuItemDefinition('INVOICE.COMMAND.GETPDF_WITH_REGULATIONS', invoiceCommand.getpdfWithRegulations),
      new MenuItemDefinition('INVOICE.COMMAND.SEND', invoiceCommand.send),
    ];
    this.menuDefinition = [
      new MenuItemDefinition('INVOICE.COMMAND.GETPDF', invoiceCommand.getpdf),
      new MenuItemDefinition('INVOICE.COMMAND.SEND', invoiceCommand.send),
    ];
  }

  @Input() itemsSource: Invoice[];

  columnDefinitions: ColumnDefinition[];
  contextMenuDefinition: MenuItemDefinition[];
  menuDefinition: MenuItemDefinition[];

  ngOnInit() {}
}
